import type { FacilityHierarchyFilterValue } from './FacilityHierarchyFilter';

type FacilityHierarchyParameterKeys = {
	areaIds?: number[];
	branchIds?: number[];
	districtIds?: number[];
	facilityIds?: string[];
};

export const applyFacilityHierarchyToParameters = <T extends FacilityHierarchyParameterKeys>(
	parameters: T,
	facilityHierarchy: FacilityHierarchyFilterValue,
): T => {
	const areaIds = facilityHierarchy.areas.map((area) => area.id);

	if (areaIds.length > 0) {
		parameters.areaIds = areaIds;
	}

	const branchIds = facilityHierarchy.branches.map((branch) => branch.id);

	if (branchIds.length > 0) {
		parameters.branchIds = branchIds;
	}

	const districtIds = facilityHierarchy.districts.map((district) => district.id);

	if (districtIds.length > 0) {
		parameters.districtIds = districtIds;
	}

	const facilityIds = facilityHierarchy.facilities.map((facility) => facility.id);

	if (facilityIds.length > 0) {
		parameters.facilityIds = facilityIds;
	}

	return parameters;
};
